import styled from 'styled-components'

export const Label = styled.label`
  display: inline-flex;
  align-items: center;

  font-family: "DM Sans";
  font-weight: 700;
  font-size: 1rem;
  
  input{
    margin: 1.5rem 0.25rem 1.5rem 2.5rem;
  }
`